import { render, staticRenderFns } from "./audioComponent.vue?vue&type=template&id=a437068a&scoped=true&"
import script from "./audioComponent.vue?vue&type=script&lang=js&"
export * from "./audioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a437068a",
  null
  
)

export default component.exports